export interface ModuleHeaderConfig {
  titleKey: string;
  descriptionKey: string;
  backRoute?: string;
  descriptionSessionKey?: string;
  actions?: {
    showButtons: boolean;
    cancelText?: string;
    submitText?: string;
    customSubmitEvent?: string;
    requiresCancelConfirm?: boolean;
    confirmTitle?: string;
    confirmMessage?: string;
  };
}

export const MODULE_HEADER_MAP: Record<string, ModuleHeaderConfig> = {
  '/dashboard': {
    titleKey: 'Dashboard',
    descriptionKey: 'Próximamente dashboard.'
  },
  '/cpd-templates': {
    titleKey: 'CPD - Templates',
    descriptionKey: 'Verifica las configuraciones activas de los templates de CPD.'
  },
  '/cpd-operators': {
    titleKey: 'CPD - Operators',
    descriptionKey: 'Verifica las configuraciones activas de los operadores de CPD.'
  },
  '/cpd-routes': {
    titleKey: 'CPD - Rutas',
    descriptionKey: 'Verifica las configuraciones activas de los rutas de CPD.'
  },
  '/cpd-overrides': {
    titleKey: 'CPD - Overrides',
    descriptionKey: 'Verifica las configuraciones activas de los overrides de CPD.'
  },
  '/routes-outgoing': {
    titleKey: 'Rutas - Salientes',
    descriptionKey: 'Verifica las configuraciones activas de las rutas salientes.'
  },
  '/routes-incomming': {
    titleKey: 'Rutas - Entrantes',
    descriptionKey: 'Verifica las configuraciones activas de las rutas entrantes.'
  },
  '/dialplan': {
    titleKey: 'Dialplan',
    descriptionKey: 'Verifica las configuraciones activas del dialplan.'
  },
  '/users': {
    titleKey: 'Usuarios',
    descriptionKey: 'Gestiona los usuarios de la plataforma.'
  }
};
